import { render, staticRenderFns } from "./PathDrawer.vue?vue&type=template&id=a0657bde&scoped=true"
import script from "./PathDrawer.vue?vue&type=script&lang=js"
export * from "./PathDrawer.vue?vue&type=script&lang=js"
import style0 from "./PathDrawer.vue?vue&type=style&index=0&id=a0657bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0657bde",
  null
  
)

export default component.exports